// extracted by mini-css-extract-plugin
module.exports =  {"alert":"apPQ2EIQvUaNg1uRv5vG"};